<template>
  <div class="loading" >
  <div class="loading-text">{{loadingText}}</div>
  </div>
</template>

<script>
export default {
  name: 'LoadingScreen',
  data: function () {
    return {
      loadingTextBase: 'Loading',
      loadingTextAdder: '.',
      loadingText: 'Loading',
      interval: null
    }
  },
  methods: {
    limitReached () {
      if (this.loadingText.includes('...')) {
        this.loadingText = this.loadingTextBase
      } else {
        this.loadingText += this.loadingTextAdder
      }
    },
    start () {
      var self = this
      this.interval = setInterval(() => {
        self.limitReached()
      }, 300)
    },
    end () {
      clearInterval(this.interval)
    }
  },
  created: function () {
    this.start()
  }
}
</script>
<style scoped>

.loading{
  margin-top: 20%;
}

.loading-text{
  font-size: 5em;
   font-style: normal
}


@media screen and (max-width:600px ) and (min-width:410px){
  .loading-text{
    font-size: 4em;
 }

}

@media screen and (max-width:410px ) and (min-width:310px){
 .loading-text{
    font-size: 3em;
  }

}
</style>
